/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb1a31d4fcdee64daf563d6901da0e46>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#e24329" d="m39.316 20.759-.04-.12-4.302-10.946a1.02 1.02 0 0 0-.446-.515 1.3 1.3 0 0 0-.67-.178c-.243 0-.467.099-.65.238a1.05 1.05 0 0 0-.385.574l-2.901 8.67H18.174l-2.902-8.67a1.2 1.2 0 0 0-.385-.574 1.1 1.1 0 0 0-.65-.238c-.243 0-.466.04-.67.178a1.02 1.02 0 0 0-.446.515L8.82 20.64l-.04.119c-1.28 3.246-.183 6.908 2.657 9.006h.04c0 .02 6.555 4.81 6.555 4.81l3.246 2.396 1.968 1.445a1.335 1.335 0 0 0 1.603 0l1.968-1.445 3.247-2.395 6.594-4.81c2.84-2.099 3.916-5.761 2.638-9.007z"/><path fill="#fc6d26" d="m39.317 21.08-.041-.12a14.85 14.85 0 0 0-5.779 2.533c-.02 0-5.11 3.779-9.45 6.964a2271 2271 0 0 0 6.003 4.43l6.59-4.806c2.839-2.097 3.913-5.757 2.636-9.001z"/><path fill="#fca326" d="m18.025 34.896 3.244 2.394 1.967 1.444a1.335 1.335 0 0 0 1.602 0l1.967-1.444 3.244-2.394s-2.798-2.057-6.002-4.431c-3.224 2.374-6.022 4.431-6.022 4.431"/><path fill="#fc6d26" d="M14.598 23.493a14.6 14.6 0 0 0-5.779-2.532l-.04.119c-1.278 3.244-.183 6.904 2.656 9h.04c0 .02 6.55 4.808 6.55 4.808s2.799-2.057 6.023-4.431c-4.32-3.185-9.409-6.944-9.45-6.964"/></svg>';

/**
 * __GitlabIcon__
 *
 * A third-party logo icon for Gitlab.
 */
export function GitlabIcon({
	size,
	label = 'Gitlab',
	testId,
	type,
	UNSAFE_isUpdatedGeometry,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper
			markup={markup}
			label={label}
			size={size}
			testId={testId}
			type={type}
			UNSAFE_isUpdatedGeometry={UNSAFE_isUpdatedGeometry}
		/>
	);
}
